export default from './follow-user-button-secure';



// WEBPACK FOOTER //
// ./app/containers/follow-user-button-secure/index.js